/**
 * ⟦C57 · lot 8 · A-174⟧ **Les blocs de « Les dessous » propres à l'enveloppe de l'Atelier** : ce que les
 * dialogues (« Jeter le projet ? », « Reprendre ta production ? », « Confier cette étape ? », les
 * erreurs du serveur) disaient en paragraphes, et que l'écran ne dit plus qu'en une ligne.
 *
 * Les dialogues maison (`AppDialog`) n'ont qu'un corps de texte : leur forme COURTE y reste, la
 * forme longue d'avant le chantier est reprise ICI, derrière le bouton « Les dessous » des écrans de
 * l'Atelier (l'intro d'une étape, « Prêt à publier »). **Rien n'est supprimé : le texte a changé de
 * place.** Les paragraphes sont ceux d'avant, au mot près (seul « celui qui est écrit ici » devient
 * « celui de l'offre », le dialogue n'étant plus là pour le montrer).
 *
 * Aucun état, aucun store : du texte et des blocs.
 */

import { DessousBloc } from "../../components/LesDessous";

/** « La production » : ce que coûte une production, ce que fait la reprise, ce que perd « Jeter ». */
export function BlocProduction() {
  return (
    <DessousBloc titre="La production">
      <p className="dessous-texte">
        Rien n'a encore été dépensé : la production ne coûte qu'à la publication.
      </p>
      <p className="dessous-texte">
        Jeter le projet, c'est perdre ce que tu as déjà fait sur cette vidéo.
      </p>
      <p className="dessous-texte">
        Si tu reprends une production en cours, tes étapes déjà notées gardent leur score ; une étape
        commencée reprend à son intro.
      </p>
    </DessousBloc>
  );
}

/** « Confier une étape » : le prix, la livraison, et ce que fait une caisse trop courte. */
export function BlocDelegation() {
  return (
    <DessousBloc titre="Déléguer">
      <p className="dessous-texte">
        Tu ne joues pas cette étape : la livraison (cote ± variance) tombe à la publication, et le prix
        est prélevé à ce moment-là, celui de l'offre, pas un autre.
      </p>
      <p className="dessous-texte">
        Seules les offres que ta caisse peut payer sont proposées ; sans de quoi payer, tu reprends les
        ciseaux.
      </p>
    </DessousBloc>
  );
}

/** « Quand le serveur note » : les deux erreurs d'une production, dans leurs mots d'avant. */
export function BlocServeur() {
  return (
    <DessousBloc titre="Quand le serveur note">
      <p className="dessous-texte">
        Une étape n'a pas laissé de trace jouable. Le serveur note l'Atelier lui-même : sans les gestes,
        il n'a rien à noter. Rejoue cette production.
      </p>
      <p className="dessous-texte">
        Le pattern de l'Atelier est tiré pour un tour. Si le tour a bougé entre-temps, reprends la
        production : sinon le serveur noterait tes gestes sur une autre partition que celle que tu as
        jouée.
      </p>
      <p className="dessous-texte">
        Une production en cours est perdue quand la partie a avancé depuis (un autre onglet ?) : la
        reprendre ferait noter tes gestes sur une autre partition.
      </p>
    </DessousBloc>
  );
}
